var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-box"},_vm._l((_vm.titleArr),function(item,index){return _c('div',{key:index,class:{'end-route':index==_vm.titleArr.length-1}},[_vm._v(_vm._s(item+(index==_vm.titleArr.length-1?'':'>')))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }